<!-- form to Reply to assigned ticket-->
<!-- checking authorization-->
<ng-container *ngIf="role && role !== 'TECHEXPERT'">
  <h1>UNAUTHORISED ACCESS</h1> <br>
  <h3>Please Login as TECHEXPERT, redirecting ...</h3>
  {{unauthorised()}}
</ng-container>
<ng-container *ngIf="serverErrorMessages">
  <div class="alert alert-danger" role="alert">
    {{ serverErrorMessages }}
  </div>
</ng-container>
<ng-container *ngIf="role && role ==='TECHEXPERT'">
  <div class="wrapper ">
    <div>
      <br><br><br>
      <div class="content">
        <div class="container-fluid form">
          <div class="row">
              <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                  <div class="card-5">
                      <div class="card-body">
                          <h2 class="card-title text-center">Please Provide your Valuable Suggestion </h2>
                          <br><br>
                          <div>
                              <div id="errorMsg" *ngIf="serverErrorMessages">
                                  <span>{{serverErrorMessages}}</span>
                              </div>
                              <!-- <div id="successMsg" *ngIf="successMessage">
                                  <span>{{successMessage}}</span>
                              </div> -->
                              <form [formGroup]="ticketReplyForm" (ngSubmit)="onSubmit()">
                                <div>
                                  <br>
                                  <div class="value">
                                    <div class="input-group">
                                      <textarea class="input--style-5"
                                        type="text"
                                        class="form-control"
                                        formControlName="message"
                                      >
                                    </textarea>
                                      <div *ngIf="ticketReplyForm.invalid">
                                        <label *ngIf="ticketReplyForm.errors.required" class="validation-message">
                                        This field is required.
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <br><br>
                                <div style="text-align: center;">
                                  <input type="submit" class="btn btn-primary" style="border-radius: 18px; position: center;" value="Reply to Ticket"/>
                                </div>
                              </form>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<!-- end of form to reply to ticket-->